export default __webpack_public_path__ + "static/magnetic_love-6d1d1a4a130fae7c6e79f62c5929a10d.png";